export default "__VITE_ASSET__ystltS8R__"